(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["press-coverage"] && !Shopify.designMode) return;
  try {
    
  const initializePressCoverage = (section) => {
    if (section.dataset.pressInitialized === 'true' || !section.classList.contains('press-coverage--editorial')) return;

    const cards = Array.from(section.querySelectorAll('[data-press-card]'));
    const filters = Array.from(section.querySelectorAll('[data-press-filter]'));
    const loadMore = section.querySelector('[data-press-load-more]');
    const results = section.querySelector('[data-press-results]');
    const initialArchiveCount = Number.parseInt(section.dataset.initialCardCount, 10) || 4;
    const featuredCardCount = Number.parseInt(section.dataset.renderedFeaturedCardCount, 10) || 2;
    const initialVisibleCount = Math.min(cards.length, initialArchiveCount + featuredCardCount);
    let activeCategory = 'all';
    let expanded = false;

    const render = () => {
      let visibleCount = 0;

      cards.forEach((card, index) => {
        const matchesCategory = activeCategory === 'all' || card.dataset.pressCategory === activeCategory;
        const matchesLimit = activeCategory !== 'all' || expanded || !loadMore || index < initialVisibleCount;
        const isVisible = matchesCategory && matchesLimit;

        card.hidden = !isVisible;
        if (isVisible) visibleCount += 1;
      });

      filters.forEach((filter) => {
        const isActive = filter.dataset.pressFilter === activeCategory;
        filter.classList.toggle('is-active', isActive);
        filter.setAttribute('aria-pressed', String(isActive));
      });

      if (loadMore) {
        loadMore.hidden = activeCategory !== 'all' || expanded || cards.length <= initialVisibleCount;
      }

      if (results) {
        results.textContent = section.dataset.resultsTemplate.replace('__count__', String(visibleCount));
      }
    };

    filters.forEach((filter) => {
      filter.addEventListener('click', () => {
        activeCategory = filter.dataset.pressFilter;
        expanded = false;
        render();
      });
    });

    if (loadMore) {
      loadMore.addEventListener('click', () => {
        const firstHiddenCard = cards.find((card) => card.hidden);
        expanded = true;
        render();
        firstHiddenCard?.querySelector('a')?.focus();
      });
    }

    section.addEventListener('shopify:block:select', (event) => {
      const selectedCard = event.target.closest('[data-press-card]');
      if (!selectedCard) return;

      activeCategory = 'all';
      expanded = true;
      render();
    });

    section.dataset.pressInitialized = 'true';
    render();
  };

  document.querySelectorAll('[data-press-coverage]').forEach(initializePressCoverage);

  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target.querySelector('[data-press-coverage]');
    if (section) initializePressCoverage(section);
  });

  } catch(e) { console.error(e); }
})();
})();
